<template>

    <div class="fixed bg-white w-full shadow flex px-5 z-50">

        <router-link :to="{ name: 'home' }" class="w-2/12 flex items-center">
        
            <img width="60" src="../assets/img/ezilly-logo.png">

            <h1 class="ml-6 text-2xl text-gray-800 uppercase" style="font-family: 'M7 Sans'">Marktime</h1>
        
        </router-link>

        <div class="w-10/12 flex justify-between">
            <h1 class="text-xl text-gray-800 border-gray-400 uppercase ml-1 py-5">{{ title }}</h1>
            
            <div class="flex items-center" v-if="currentUser">
                <div class="mr-2 font-thin py-5">Hi!</div> 
                <div class="mr-4 py-5">{{ currentUser.name }}</div> 
                <div class="dropdown relative text-gray-500 hover:text-gray-800 focus:text-gray-800 py-5">
                    <div class="flex items center cursor-pointer">
                        <div class="h-7">
                            <Zondicon icon="user-solid-circle" class="w-6 h-6 fill-current" />
                        </div>
                        <div class="flex ml-2">
                            <Zondicon icon="cheveron-down" class="w-6 h-6 mr-5 fill-current" />
                        </div>
                    </div>
                    <div class="dropdown-list absolute hidden bg-white right-0 w-48 shadow text-gray-800" style="top:60px">
                        <router-link :to="{ name: 'settings'}" class="flex px-4 py-3 hover:bg-gray-200" href="#">
                            <Zondicon icon="user" class="w-3 h-6 mr-5 fill-current" />
                            <span class="text-sm">Profile</span>
                        </router-link>
                        <a class="flex px-4 py-3 hover:bg-gray-200" href="#" @click.prevent="logout">
                            <Zondicon icon="arrow-outline-left" class="w-3 h-6 mr-5 fill-current" />
                            <span class="text-sm">Logout</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
import { mapState } from 'vuex'
import { auth } from '@/firebase'
import Zondicon from 'vue-zondicons'

export default {

    computed: {
        ...mapState({
            currentUser: state => state.user.info,
            title: 'title'
        })
    },

    components: {
      Zondicon
    },

    methods: {
        logout() {
            auth.signOut().then(() => {
                this.$router.go('login')
            })
        }
    }

}
</script>

<style lang="scss">
    .dropdown:hover {
        .dropdown-list {
            display: block !important;
        }
    }
</style>
